import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {ND} from '@pt/pt-models';
import {WaaImplementedValue, WaaPreview, WaaQueryMapping, WaaValue} from './models/widget-app-assessment-v0-args.dto';

@Component({
  selector: 'pt-waa-editor',
  template: `
    <table class="table table-striped" *ngIf="data">
      <tbody>
      <tr *ngFor="let row of data.queryMappingValue; let i = index">
        <td style="min-width: 200px; max-width: 200px;">
          <pt-waa-edit-row-col1
            [internalId]="row.internalId"
            [checkValue]="row.checkValue">
          </pt-waa-edit-row-col1>
        </td>
        <td>
          <pt-waa-edit-row-col2
            [description]="row.description"
            [scenarioR]="row.scenarioR"
            [scenarioI]="row.scenarioI"
            [scenarioD]="row.scenarioD"
            [normativeReference]="row.normativeReference"
            [category]="row.category"
            [header]="data.header">
          </pt-waa-edit-row-col2>
        </td>
        <td style="max-width: 185px;">
          <pt-waa-edit-row-col3
            [uuid]="row.uuid"
            [disabled]="disabled"
            [scenarioR]="row.scenarioR"
            [scenarioI]="row.scenarioI"
            [scenarioD]="row.scenarioD"
            [value]="widgetValue"
            [implemented]="currentImplemented"
            (changeRowImplementedValue)="changeRowImplementedValue(row, $event)">
          </pt-waa-edit-row-col3>
        </td>
        <td [ngStyle]="row.scenarioD || row.scenarioI || row.scenarioR ? { minWidth: '90px'} : {minWidth: '250px'}">
          <pt-waa-edit-row-col4
            [viewMode]="row.scenarioD || row.scenarioI || row.scenarioR ? 'DIALOG' : 'TEXTAREA'"
            [uuid]="row.uuid"
            [disabled]="disabled"
            [value]="widgetValue"
            [headerNode]="data?.header?.note"
            (changeNote)="changeRowNote(row, $event)">
          </pt-waa-edit-row-col4>
        </td>
      </tr>
      </tbody>
    </table>
  `,
})
export class WaaEditorComponent implements OnChanges {
  @Input() show: boolean;
  @Input() disabled = false;
  @Input() noResponseLabel: string;
  @Input() data: WaaPreview;
  @Input() widgetValue: WaaValue[];
  @Output() changeWidgetValue = new EventEmitter<WaaValue>();
  ND = ND;
  currentImplemented: WaaImplementedValue[] = [];

  ngOnChanges(): void {
    if (this.data && this.data.implementedValues) {
      const implemented: WaaImplementedValue[] = JSON.parse(JSON.stringify(this.data.implementedValues))
      this.currentImplemented = [
        {
          value: -1000,
          label: this.noResponseLabel,
          help: '',
          color: '#ffff83'
        },
        ...implemented];
    } else {
      this.currentImplemented = [];
    }

  }

  changeRowNote(row: WaaQueryMapping, note: string) {
    /**
     * Se nel ciclo for sottostante non trovo il valore salvato nel widget questo inizializzato va bene
     */
    let currentValue: WaaValue = {
      uuid: row.uuid,
      note: note,
      implementedValue: undefined
    };

    this.widgetValue.forEach((v) => {
      if (v.uuid === row.uuid) {
        /**
         * Sovrascrivo solo lo uuid senza cancellare le note
         */
        currentValue = {
          uuid: row.uuid,
          note: note,
          implementedValue: v.implementedValue
        }
      }
    })

    this.changeWidgetValue.emit(currentValue);
  }

  changeRowImplementedValue(row: WaaQueryMapping, implementedValue: number) {
    /**
     * Se nel ciclo for sottostante non trovo il valore salvato nel widget questo inizializzato va bene
     */
    let currentValue: WaaValue = {
      uuid: row.uuid,
      note: undefined,
      implementedValue: implementedValue
    };

    this.widgetValue.forEach((v) => {
      if (v.uuid === row.uuid) {
        /**
         * Sovrascrivo solo lo uuid senza cancellare le note
         */
        currentValue = {
          uuid: row.uuid,
          note: v.note,
          implementedValue: implementedValue
        }
      }
    })
    this.changeWidgetValue.emit(currentValue);
  }
}
